<template>
  <div class="form-row">
    <div class="form-label">{{ info.displayName }}</div>
    <div class="form-contro" v-if="isMobile != 1">
      <a-select
        placeholder="请选择"
        @change="info.setValue()"
        v-model="info.model"
        :allowClear="true"
        v-if="info.isCascade !== 1"
        :disabled="info.disabled"
      >
        <a-select-option v-for="o in info.listOptions" :key="o.optionValue">
          {{ o.optionValue }}
        </a-select-option>
      </a-select>
      <a-cascader
        v-if="info.isCascade === 1"
        :options="info.listOptions"
        v-model="info.model"
        @change="info.setValue()"
        placeholder="请选择"
        :disabled="info.disabled"
      />
    </div>
    <div class="form-contro form-picker" v-if="isMobile == 1">
      <input
        type="text"
        class="form-input"
        v-model="info.model"
        readonly
        @focus="showAlert()"
        placeholder="请选择"
      />
      <span class="icon icontemp down" v-if="!info.value"></span>
      <span
        class="icon icontemp clear"
        v-if="info.value"
        @click="info.clearModel()"
      ></span>
    </div>
    <div class="form-error" v-if="info.dirty && info.invalid">
      {{ info.validationMessage }}
    </div>
    <van-popup
      v-model="show"
      position="bottom"
      get-container="body"
      :disabled="info.disabled"
    >
      <van-picker
        ref="picker"
        :columns="info.columns"
        :show-toolbar="true"
        @cancel="hideAlert"
        @confirm="vantChange"
      />
    </van-popup>
  </div>
</template>

<script>
import { interact } from "fire-wind-water/tools/interact";

export default {
  name: "SSelect",
  props: {
    info: {}
  },
  data() {
    return {
      isMobile: interact.isMobile,
      show: false,
      values: []
    };
  },
  methods: {
    vantChange(e) {
      this.show = false;
      this.info.setModel(e);
    },
    showAlert() {
      this.show = true;
      if (this.$refs.picker) {
        this.$refs.picker.setValues(this.info.value || []);
      } else {
        setTimeout(() => {
          this.$refs.picker.setValues(this.info.value || []);
        }, 100);
      }
    },
    hideAlert() {
      this.show = false;
    }
  },
  created() {}
};
</script>

<style scoped></style>
